import combineActionHandlers from "@web-monorepo/infra/combineActionHandlers";
import createAction from "@web-monorepo/infra/createAction";
import createActionCreator from "@web-monorepo/infra/createActionCreator";
import createReducer from "@web-monorepo/infra/createReducer";
import { PodInstallFunction } from "@web-monorepo/shared/podInfra";
import { autoTranslate } from "@web-monorepo/vite-auto-translate-plugin/runtime";
import { AppMetadata } from "src/pods/toolkitData/components/EditableSetup";
import icon from "./assets/logo.svg";

export const appMetadataRadio = (): AppMetadata => ({
  href: "radio",
  title: autoTranslate("Music"),
  icon,
  backgroundColor: "dt_content_warning",
});

type Track = {
  src: string;
};
export type RadioChannel = {
  title: string;
  icon: string;
  tracks: Track[];
};
export type Radio = {
  mountPoint: string;
  classId: string;
  synced: boolean;
  channel?: RadioChannel;
  currentTrackIndex: number;
  playing: boolean;
};

const initialState = {};

export const SEND_RADIO = createAction("SEND_RADIO");
export const RECEIVE_RADIO = createAction("RECEIVE_RADIO");

export const sendRadioHandler = createReducer(SEND_RADIO, (payload: Radio) => (state: Radio) => ({
  ...state,
  ...payload,
}));

export const receiveRadioHandler = createReducer(RECEIVE_RADIO, (payload: Radio) => (state: Radio) => ({
  ...state,
  ...payload,
}));

export type SendRadioProps = {
  channel?: RadioChannel | null;
  currentTrackIndex?: number;
  playing?: boolean;
};
export const sendRadio = createActionCreator(SEND_RADIO, ({ channel, currentTrackIndex, playing }: SendRadioProps) => ({
  synced: true,
  channel,
  currentTrackIndex,
  playing,
}));

const STATE_KEY = "radio";

const reducer = combineActionHandlers(initialState, [receiveRadioHandler, sendRadioHandler]);

const install: PodInstallFunction = (installReducer) => {
  installReducer(STATE_KEY, reducer);
};

export default install;
